module.exports = __webpack_public_path__ + "img/heart_filled.37b942ca.svg";